
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Phone, User } from "lucide-react";
import { motion } from "framer-motion";

interface ContactInfoProps {
  name: string;
  setName: (value: string) => void;
  phone: string;
  setPhone: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
}

export const ContactInfo = ({
  name,
  setName,
  phone,
  setPhone,
  email,
  setEmail
}: ContactInfoProps) => {
  return (
    <>
      <motion.div whileHover={{ scale: 1.02 }} className="transition-all duration-300">
        <Label htmlFor="name" className="flex items-center gap-2">
          <User className="w-4 h-4" />
          Full Name
        </Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          placeholder="Enter your full name"
          className="transition-all duration-300 hover:border-navy-600"
        />
      </motion.div>

      <motion.div whileHover={{ scale: 1.02 }} className="transition-all duration-300">
        <Label htmlFor="phone" className="flex items-center gap-2">
          <Phone className="w-4 h-4" />
          Phone Number
        </Label>
        <Input
          id="phone"
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
          placeholder="Enter your phone number"
          className="transition-all duration-300 hover:border-navy-600"
        />
      </motion.div>

      <motion.div whileHover={{ scale: 1.02 }} className="transition-all duration-300">
        <Label htmlFor="email" className="flex items-center gap-2">
          <Mail className="w-4 h-4" />
          Email
        </Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="Enter your email"
          className="transition-all duration-300 hover:border-navy-600"
        />
      </motion.div>
    </>
  );
};
